<template>
    <section class="section-class-personal-page">
        <div class="ss-breadcrumb">
            <div class="container-hts">
                <ul class="margin-0 p-0">
                    <li><router-link to="/lop-hoc">Lớp học</router-link></li>
                    <li><router-link to="/lop-hoc">Trang cá nhân</router-link></li>
                    <li><router-link to="">{{ nameClass }}</router-link></li>
                </ul>
            </div>
        </div>
        <div class="container">
            <div class="pt-4">
                <h2 class="font-weight-bold">{{ nameClass }}</h2>
            </div>
            <b-tabs class="pre-class-school-list__filter__tabs">
                <b-tab title="Bài tập/ bài kiểm tra đã giao" @click="handleChangeTab(tabExcercise)" :active="tabActive == tabExcercise">
                    <TabExcercise v-if="tabActive == tabExcercise" :nameClass="nameClass" />
                </b-tab>
                <b-tab title="Bài giảng điện tử đã giao" @click="handleChangeTab(tabElectronicLecture)" :active="tabActive == tabElectronicLecture">
                    <TabElectronicLecture v-if="tabActive == tabElectronicLecture" :nameClass="nameClass" />
                </b-tab>
                <b-tab title="Kế hoạch bài dạy đã giao" @click="handleChangeTab(tabLessonPlanning)" :active="tabActive == tabLessonPlanning">
                    <TabLessonPlaning v-if="tabActive == tabLessonPlanning" :nameClass="nameClass" />
                </b-tab>
            </b-tabs>
        </div>
    </section>
</template>
<script>
import TabExcercise from './_components/TabExcercise'
import TabElectronicLecture from './_components/TabElectronicLecture.vue'
import TabLessonPlaning from './_components/TabLessonPlaning.vue'
export default{
    components:{
        TabExcercise,
        TabElectronicLecture,
        TabLessonPlaning
    },
    data(){
        return{
            nameClass: '',
            tabActive:1,
            tabExcercise:1,
            tabElectronicLecture:2,
            tabLessonPlanning:3,
        }
    },
    mounted(){
        this.nameClass = this.$router.history.current.query.nameClass
    },
    methods:{
        handleChangeTab(tab){
            this.tabActive = tab
        }
    }
}
</script>